//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import list from "@/components/list.vue";

  export default {
    name: "lists",
    components: {
      //sSwiper,
      //SwiperSlide
      list
    },
    data() {
      return {
        show: false,
        loading: false,
        loadingArr: [],
        swiperOption: {
          slidesPerView: "auto",
          //slidesPerView: 1.5,
          freeMode: true,
          spaceBetween: 0,
          pagination: {
            // el: '.swiper-pagination',
            clickable: false
          }
        },
        bookId: '',
        code: '',
        titleData: '',
        tabData: [],
        tabIndex: 0,
        tabSubIndex: 0,
        iconAuthor: require("@/assets/image/icon/icon_author.png"),
        noChildren: -1
      };
    },
    methods: {
      //返回上一页
      onClickLeft(){
        this.$router.go(-1)
      },
      getTree(){
        let postD = {
          //code: "ALL",
          code: this.code, //電子書
        };
        //this.$toast.loading();
        this.GLOBAL_.ccRequest
          .doAxios(this.CONFIG.COLUMN.GETTREE, postD, "GET", "no login", false, "set storage")
          .then(res => {
            //console.log("分類", res);
            this.show = true;
            //this.$toast.close();
            //let all1 = {classId: '001', className:"全部"}
            let datas = this.tabData
            let ischildren = false;
            this.code = res.code;
            res[0].children.forEach((i,ind) => {
              var subDatas = [];
              if(i.children.length > 0){
                ischildren = true
                i.children.forEach((i2,ind2) => {
                  let obj2 = {
                    total: '',
                    pageNo: 1,
                    list: [],
                    finished: false,
                    data: i2,
                    className: i2.className,
                    classId: i2.classId,
                    code: res[0].code
                  }
                  if(ind2 == 0){
                    obj2['parentIds'] = i.parentIds
                  }else{
                    obj2['parentIds'] = i2.parentIds
                  }
                  subDatas[ind2] = obj2
                })
              }
              let obj = {
                list: [],
                children: subDatas,
                total: '',
                pageNo: 1,
                finished: false,
                data: i,
                className: i.className,
                classId: i.classId,
                code: res[0].code
              }
              if(ind == 0){
                obj['parentIds'] = res[0].parentIds
              }else{
                obj['parentIds'] = i.parentIds
              }
              datas[ind] = obj;

            })
            //console.log("分類11", this.tabData);
            console.log("類目", datas);
            this.tabData = datas
            this.getData(datas[0], datas[0].pageNo);

          }).catch(err => {

          });
      },
      reData(data, pageNo, index1, index2, finished){
        if(index2 == -1){
          this.tabData[index1].list = this.tabData[index1].list.concat(data);
          this.tabData[index1].pageNo = pageNo
          this.tabData[index1].finished = finished
        }else{
          this.tabData[index1].children[index2].list = this.tabData[index1].children[index2].list.concat(data);
          this.tabData[index1].children[index2].pageNo = pageNo
          this.tabData[index1].children[index2].finished = finished
        }
        this.$forceUpdate();
      },
      getData(obj, pageNo){
        //this.$toast.loading();
        let id = obj.parentIds + "/" + obj.classId;
        let postD = {
          pageSize: 24,
          pageNo: pageNo,
          code: obj.code,
          cmsClassIds: id
        }

        this.GLOBAL_.ccRequest
          .doAxios(this.CONFIG.COLUMN.CLASSSEARCH, postD, "GET", "no login", false, "set storage")
          .then(res => {
            //console.log("內容" + obj.className, res);
            //this.$toast.close();
            obj.total = res.total
            if(res.total < 24){
              obj.finished = true;
            }
            obj.list = res.rows;

            this.$forceUpdate();
            //console.log('obj.tabData11', this.tabData);

          }).catch(err => {
            console.log('err', err);
          });
      },
      onTab(ind){
        //console.log(this.tabData,ind);
        this.tabIndex = ind
        this.tabSubIndex = 0;
        let list = this.tabData[this.tabIndex].list.length,
            total = this.tabData[this.tabIndex].total,
            finished = this.tabData[this.tabIndex].finished,
            pageNo = this.tabData[this.tabIndex].pageNo,
            datas = this.tabData[this.tabIndex]
        if(list >= total && list > 0){
          finished = true
          //console.log('加载完成');
        }else if(pageNo == 1){
          if(this.tabData[this.tabIndex].children.length > 1){
            this.getData(this.tabData[this.tabIndex].children[0], this.tabData[this.tabIndex].children[0].pageNo);
          }else{
            this.getData(datas, pageNo);
          }
        }
        this.$forceUpdate();
      },
      onSubTab(ind){
        //console.log('onSubTab',ind);
        //document.documentElement.scrollTop=0;// 滚动到顶部
        this.tabSubIndex = ind
        let list = this.tabData[this.tabIndex].children[this.tabSubIndex].list.length,
            total = this.tabData[this.tabIndex].children[this.tabSubIndex].total,
            finished = this.tabData[this.tabIndex].children[this.tabSubIndex].finished,
            pageNo = this.tabData[this.tabIndex].children[this.tabSubIndex].pageNo,
            datas = this.tabData[this.tabIndex].children[this.tabSubIndex]
        if(list >= total && list > 0){
          // 数据全部加载完成
          finished = true
          //console.log('加载完成');
        }else if(pageNo == 1){
          this.getData(datas, pageNo);
          //console.log('加载中');
        }
        this.$forceUpdate();
      },
      gotoTarget2(item,ind) {
        //let item = this.list[ind];
        //console.log('item',item);
        let types = item.mediaType; //类型
        let target = this.targetL[types];
        if (target == undefined) {
          //未配置的目標地址
          // console.log("error", "未配置的目標地址");
          return;
        }
        let pArr = target.params;
        let q = {};
        let obj = {};
        obj["path"] = target.path;
        console.log('pArr',pArr);
        pArr.forEach(p => {
          let val = item[p.name];
          //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
          let key = p.label ? p.label : p.name;
          q[key] = val;
        });

        obj["query"] = q;
        console.log(obj, q);
        //跳轉音頻詳情頁需要提前判斷是否登錄
        //this.$router.replace(obj)
        this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
      },
      switchData(id){
        switch(id){
          case 'audio':
            this.titleData = this.$t('INDEX_LANG.menu.2');
            this.code = 'audio';
            break;
          case 'ebook':
             this.titleData = this.$t('INDEX_LANG.menu.3');
             this.code = 'ebook';
             break;
          case 'course':
            this.titleData = this.$t('INDEX_LANG.menu.1');
            this.code = 'course';
            break;
          case 'sayingbook':
            this.titleData = this.$t('INDEX_LANG.menu.0');
            this.code = 'talk_book';
            break;
          case 'video':
            this.titleData = this.$t('INDEX_LANG.menu.4');
            this.code = 'video';
            break;
        }
      }

    },
    mounted() {
      this.bookId = this.$route.query.id;
      this.switchData(this.$route.query.id);
      //console.log("tabData",this.tabData.length);
      if(this.tabData.length == 0){
        this.getTree();
      }
    },
    beforeRouteLeave(to, from, next) {
      //console.log('to', to.path, to);
      if(to.path == '/detail' || to.path == '/ebookDetail' || to.path == '/audioDetail' || to.path == '/videoDetail') {
        from.meta.keepAlive = true
      } else {
        from.meta.keepAlive = false
      }
      next()
    }
  };
  


// WEBPACK FOOTER //
// ./src/pages/lists.vue